import computeScrollIntoView from 'compute-scroll-into-view';

/**
 * Guarded scrollIntoView for downshift menus. The guard (`!menuNode`) prevents
 * compute-scroll-into-view from climbing every scrollable ancestor up to
 * `document` when the menu is portaled and not yet in the DOM (e.g. during the
 * layout effect that runs on mount with `defaultIsOpen: true`).
 */
export const safeScrollIntoView = (
  node: HTMLElement,
  menuNode: HTMLElement,
): void => {
  if (!node || !menuNode) {
    return;
  }

  const actions = computeScrollIntoView(node, {
    boundary: menuNode,
    block: 'center',
    scrollMode: 'if-needed',
  });
  actions.forEach(({ el, top, left }) => {
    el.scrollTop = top;
    el.scrollLeft = left;
  });
};
